<template>
  <div class="dialog-wrapper">
    <el-dialog
      :title="
        readyOnly
          ? `查看${titleName}指标`
          : isEditMode
          ? `编辑${titleName}指标`
          : `添加${titleName}指标`
      "
      :visible.sync="isShowDialog"
      width="580px"
      :before-close="dialogBeforeClose"
    >
      <div class="h390">
        <vue-scroll :ops="ops">
          <el-form
            :model="formData"
            :rules="formDataRules"
            :label-width="'120px'"
            ref="formDom"
          >
            <el-form-item label="指标名称" prop="targetName">
              <el-input
                class="yioks-form-item"
                v-model.trim="formData.targetName"
                :disabled="readyOnly"
                placeholder="请填充指标名称"
              ></el-input>
            </el-form-item>
            <el-form-item label="指标分值" prop="targetTotalScore">
              <el-input
                class="yioks-form-item"
                placeholder="请填充指标分值（示例：10）"
                v-model.trim.number="formData.targetTotalScore"
                :disabled="readyOnly"
              ></el-input>
            </el-form-item>
            <el-form-item label="指标权重" prop="weight">
              <el-input
                class="yioks-form-item"
                placeholder="请填充指标权重（示例：10）"
                v-model.trim.number="formData.weight"
                :disabled="readyOnly"
              ></el-input>
            </el-form-item>

            <el-form-item label="指标备注" prop="targetRemark">
              <el-input
                type="textarea"
                class="yioks-form-item"
                v-model="formData.targetRemark"
                placeholder="请填写指标备注"
                :disabled="readyOnly"
                :rows="3"
              ></el-input>
            </el-form-item>

            <el-form-item label="指标建议" prop="targetSuggest">
              <el-input
                type="textarea"
                class="yioks-form-item"
                v-model="formData.targetSuggest"
                placeholder="请填写指标建议"
                :disabled="readyOnly"
                :rows="3"
              ></el-input>
            </el-form-item>
          </el-form>
        </vue-scroll>
      </div>
      <div slot="footer" class="footer-btn-group" v-if="!readyOnly">
        <el-button type="primary" @click="handleDialogAction(true)"
          >确 定</el-button
        >
        <el-button type="danger" @click="handleDialogAction(false)"
          >取 消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { requiredItem, numberRequired } from "@/assets/js/formRules";
import { performanceGroupTypeList, gradeType } from "@/assets/js/yioksSelect";
import { postTarget, putTarget, addSecondTarget, editSecondTarget } from "@/api/performance";
import { ops } from "@/utils/scrollIndialog";

export default {
  props: {
    isShowDialog: {
      type: Boolean,
      default: false,
      required: true,
    },
    maxScore: {
      type: Number,
      default: 0,
      required: false,
    },
    isLimitMaxScore: {
      type: Boolean,
      default: false,
      required: false,
    },
    defaultFormData: {
      type: Object,
      default() {
        return {
          targetName: "", // 指标名称
          targetTotalScore: "", // 指标总分值
          // targetType: "TALLEST", // 计分类型
          weight: "", // 权重 Number
          // jixiaoType: "", // 指标类型
          groupUuid: "", // 绩效组uuid  // 初始填值
          targetRemark: "", // 指标备注
          targetSuggest: "", // 指标建议
          isFileChanged: false,
        };
      },
    },

    isEditMode: {
      type: Boolean,
      default: false,
      required: false,
    },

    titleName: {
      type: String,
      default: "",
      required: false,
    },

    readyOnly: {
      type: Boolean,
      default: false,
      required: false,
    },
  },

  data() {
    return {
      ops,
      // uploadPath: '/api/zuxie/guozi/upload/uploadJixiaoFile',
      uploadPath: "/api/zuxie/guozi/upload/jixiao",
      formData: {
        targetName: "", // 指标名称
        targetTotalScore: "", // 指标总分值
        // targetType: "TALLEST", // 计分类型
        weight: "", // 权重 Number
        // jixiaoType: "", // 指标类型
        groupUuid: "", // 绩效组uuid  // 初始填值
        targetRemark: "", // 指标备注
        targetSuggest: "", // 指标建议

      },
      performanceGroupTypeList, // 指标类型列表
      gradeType,
    };
  },

  computed: {
    groupNameUuid() {
      const { groupUuid } = this.$route.params;
      return groupUuid;
    },
    // 表单验证规则
    formDataRules() {
      const rules = {
        targetName: [requiredItem("指标名称")],
        targetTotalScore: [
          requiredItem("指标分值"),
          numberRequired("指标分值"),
          {
            required: false,
            validator: (rule, value, callBack) => {
              if (this.isLimitMaxScore) {
                if (value !== "") {
                  if (value > this.maxScore) {
                    callBack(
                      new Error(`当前指标最多允许分值为${this.maxScore}分`)
                    );
                  } else {
                    callBack();
                  }
                } else {
                  callBack();
                }
              } else {
                callBack();
              }
            },
            trigger: "blur",
          },
        ],
        weight: [requiredItem("权重"), numberRequired("权重", true)],
        // targetType: [requiredItem("计分类型")],
        // jixiaoType: [requiredItem("指标类型")],
      };
      return rules;
    },
  },

  created() {
    this.initFormData(); // 填充原始表单
  },

  methods: {
    // 对原始表单填值
    initFormData() {
      if (this.groupNameUuid)
        this.$set(this.formData, "groupUuid", this.groupNameUuid);
      if (this.isEditMode) {
        this.formData = Object.assign({}, this.formData, this.defaultFormData);
      }
    },

    // 表单操作
    handleDialogAction(confirm) {
      if (confirm) {
        this.$refs.formDom.validate((valid) => {
          if (valid) {
            let requestName = this.isEditMode ? putTarget : postTarget;
            let submitData =  this.formData;
            requestName(submitData)
              .then((res) => {
                if (res.code) {
                  this.$message.error(res.msg);
                  this.setCallBack(true, false);
                  return;
                }
                this.setCallBack(false, true);
              })
              .catch((err) => {
                console.error("err", err);
                this.setCallBack(false, false);
              });
          } else {
            console.warn("校验未通过");
          }
        });
      } else {
        // this.$emit("update:isShowDialog", false);
        this.setCallBack(false, false);
      }
    },

    // 设置弹窗状态
    setDialogStatus(status) {
      this.$emit("update:isShowDialog", status);
    },

    // 设置弹窗回调方法
    setCallBack(dialogStatus, successStatus) {
      this.$emit("closeDialogCallBack", dialogStatus, successStatus);
    },

    // 弹窗关闭
    dialogBeforeClose() {
      this.setCallBack(false, false);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.yioks-form-item
  width 340px
.footer-btn-group
  width 60%
  margin 0 auto
  display flex
  justify-content space-around
.h390
  height 390px
</style>
